import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { 
    ResponsiveContainer, 
    LineChart, 
    Line, 
    XAxis, 
    YAxis, 
    CartesianGrid, 
    Tooltip as ChartTooltip, 
    Legend, 
    AreaChart, 
    Area 
} from "recharts";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@mui/material/Tooltip';
import CallIcon from "@mui/icons-material/Call"; // Ícone de telefone do Material UI

import AppBar from '@mui/material/AppBar';
import SwipeableViews from 'react-swipeable-views';
import SensorsIcon from "@mui/icons-material/Sensors"; // Ícone para Zonas
import AccountTreeIcon from "@mui/icons-material/AccountTree"; // Ícone para Partições
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

import { Stomp } from '@stomp/stompjs';

import Close from '@material-ui/icons/Close'
import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';
import Hls from "hls.js";

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';
import { Card, CardContent } from "@mui/material";

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Modal from "react-modal";
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';



import {
    MaterialReactTable
} from 'material-react-table';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power';



import api from '../../../../../../services/api';


import NavegadorGestao from "../../../../../../components/NavBarGestao";


import switch_off from '../../../../../../assets/imgs/switch-off.png';
import switch_on from '../../../../../../assets/imgs/switch-on.png';


import mini_icone_carro from '../../../../../../assets/imgs/mini_icone_carro.png';

import mini_icone_moto from '../../../../../../assets/imgs/mini_icone_moto.png';

import icone_origem from '../../../../../../assets/imgs/icone_origem.png';
import icone_destino from '../../../../../../assets/imgs/icone_destino.png';
import icone_parada from '../../../../../../assets/imgs/icone_parada.png';

import icone_call from '../../../../../../assets/imgs/icone_call.png';


import cabo_conectado from '../../../../../../assets/imgs/cabo_conectado.png';
import cabo_desconectado from '../../../../../../assets/imgs/cabo_desconectado.png';
import cabo_internet from '../../../../../../assets/imgs/cabo_internet.png';
import cabo_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import wifi_conectado from '../../../../../../assets/imgs/cabo_conectado.png';

import modem_conectado from '../../../../../../assets/imgs/modem_conectado.png';
import modem_desconectado from '../../../../../../assets/imgs/modem_desconectado.png';
import modem_internet from '../../../../../../assets/imgs/cabo_internet.png';
import modem_sem_internet from '../../../../../../assets/imgs/cabo_sem_internet.png';

import icone_pgm from '../../../../../../assets/imgs/icone_pgm.png';
import icone_corneta from '../../../../../../assets/imgs/corneta.png';

import icone_play from '../../../../../../assets/imgs/play.png';


import icone_medidor from '../../../../../../assets/imgs/icone_medidor.png';

import icone_subestacao from '../../../../../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../../../../../assets/imgs/icone_casa.png';
import icone_loja from '../../../../../../assets/imgs/icone_loja.png';
import icone_central from '../../../../../../assets/imgs/icone_central.png';

import icone_instalacoes from '../../../../../../assets/imgs/icone_instalacoes.png';
import icone_equipamentos from '../../../../../../assets/imgs/icone_equipamentos.png';

import icone_armar_stay from '../../../../../../assets/imgs/armar_stay.png';
import icone_armar_away from '../../../../../../assets/imgs/armar_away.png';
import icone_desarmar from '../../../../../../assets/imgs/desarmar.png';
import globalConfig from '../../../../../../configs/globalConfigs';





import {
    GoogleMap,
    Marker,
    LoadScript,
    OverlayView,
    StandaloneSearchBox,
    DirectionsService,
    DirectionsRenderer,
    DistanceMatrixService,
     Circle, Polygon, Polyline
} from "@react-google-maps/api";

import "./MapPage.css";
import alarmeAudio from '../../../../../../assets/mp3/alarme.mp3';
import LocationOnIcon from '@mui/icons-material/LocationOn';

// Replaced react-leaflet with raw Leaflet for stability in mixed MUI environments
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;




export default function ModuloSentinelComponent({ lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, instalacao, flag }) {


    //const { lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, instalacao, flag } = props;
    const tempoInativo = 30;

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const handleThemeChange = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        const intervalId = setInterval(handleThemeChange, 1000);
        window.addEventListener('storage', handleThemeChange);
        window.addEventListener('themeChange', handleThemeChange);
        window.addEventListener('darkModeChanged', handleThemeChange);
        window.addEventListener('temaChanged', handleThemeChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleThemeChange);
            window.removeEventListener('themeChange', handleThemeChange);
            window.removeEventListener('darkModeChanged', handleThemeChange);
            window.removeEventListener('temaChanged', handleThemeChange);
        };
    }, []);









    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    // Control for Map Hover display without breaking React-Leaflet Context
    const [showMap, setShowMap] = useState(false);
    const [mapReady, setMapReady] = useState(false);
    const mapRef = useRef(null);

    useEffect(() => {
        setMapReady(true);
    }, []);

    // Manual Leaflet init to avoid Context Errors
    useEffect(() => {
        if (showMap && mapReady && mapRef.current && equipamento.modulo_sentinel.latitude) {
            const lat = parseFloat(equipamento.modulo_sentinel.latitude);
            const lng = parseFloat(equipamento.modulo_sentinel.longitude);
            
            // Brief timeout to ensure div is rendered and has dimensions
            const timeoutId = setTimeout(() => {
                if (!mapRef.current) return;
                
                const map = L.map(mapRef.current).setView([lat, lng], 16);
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap'
                }).addTo(map);
                
                L.marker([lat, lng]).addTo(map);
                
                // Save instance to ref if needed for cleanup, or just return cleanup
                return () => {
                    map.remove();
                };
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [showMap, mapReady, equipamento.modulo_sentinel.latitude, equipamento.modulo_sentinel.longitude]);

    const [openLogTable, setOpenLogTable] = useState(false);

    // Tracking History State
    const [openModalRastreamento, setOpenModalRastreamento] = useState(false);
    const [historicoRastreamento, setHistoricoRastreamento] = useState([]);
    const [loadingHistorico, setLoadingHistorico] = useState(false);
    const mapHistoricoRef = useRef(null);

    const [openModalBateria, setOpenModalBateria] = useState(false);
    const [dadosBateria, setDadosBateria] = useState(null);
    const [loadingBateria, setLoadingBateria] = useState(false);

    const handleAbrirBateria = async () => {
        setOpenModalBateria(true);
        setLoadingBateria(true);
        try {
            const response = await api.get(`v1/protected/registrosentinel/bateria/${equipamento.modulo_sentinel.id_modulo_sentinel}`);
            setDadosBateria(response.data);
        } catch (error) {
            console.error("Erro ao buscar dados de bateria:", error);
            setSnackbarMessage("Erro ao carregar análise de bateria");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setLoadingBateria(false);
        }
    };

    const handleAbrirRastreamento = async () => {
        setOpenModalRastreamento(true);
        setLoadingHistorico(true);
        try {
            const response = await api.get(`v1/protected/modulosentinel/historico/${equipamento.modulo_sentinel.id_modulo_sentinel}`);
            setHistoricoRastreamento(response.data);
        } catch (error) {
            console.error("Erro ao buscar histórico:", error);
            setSnackbarMessage("Erro ao carregar histórico de rastreamento");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setLoadingHistorico(false);
        }
    };

    // History Map Init
    useEffect(() => {
        if (openModalRastreamento && !loadingHistorico && mapHistoricoRef.current && historicoRastreamento.length > 0) {
            const timeoutId = setTimeout(() => {
                if (!mapHistoricoRef.current) return;
                
                const lastPoint = historicoRastreamento[historicoRastreamento.length - 1];
                const map = L.map(mapHistoricoRef.current).setView([parseFloat(lastPoint.latitude), parseFloat(lastPoint.longitude)], 14);
                
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap'
                }).addTo(map);

                const points = historicoRastreamento.map(p => [parseFloat(p.latitude), parseFloat(p.longitude)]);
                
                // Path Polyline
                if (points.length > 1) {
                    L.polyline(points, { color: '#3b82f6', weight: 4, opacity: 0.7 }).addTo(map);
                }

                // Markers
                historicoRastreamento.forEach((p, idx) => {
                    const isLast = idx === historicoRastreamento.length - 1;
                    const isFirst = idx === 0;
                    
                    if (isLast) {
                        L.marker([parseFloat(p.latitude), parseFloat(p.longitude)]).addTo(map)
                            .bindPopup(`<b>Última Posição</b><br/>${moment(p.data_hora_gps).format("HH:mm:ss DD/MM")}`);
                    } else if (isFirst) {
                        L.circleMarker([parseFloat(p.latitude), parseFloat(p.longitude)], { radius: 6, color: 'green', fillOpacity: 0.8 }).addTo(map)
                            .bindPopup(`<b>Início (3 dias)</b><br/>${moment(p.data_hora_gps).format("HH:mm:ss DD/MM")}`);
                    } else if (idx % 5 === 0) { // Show some intermediate points
                        L.circleMarker([parseFloat(p.latitude), parseFloat(p.longitude)], { radius: 4, color: '#3b82f6', fillOpacity: 0.5 }).addTo(map)
                            .bindPopup(`${moment(p.data_hora_gps).format("HH:mm:ss DD/MM")}`);
                    }
                });

                if (points.length > 0) {
                    const group = new L.featureGroup(points.map(p => L.marker(p)));
                    map.fitBounds(group.getBounds().pad(0.1));
                }

                return () => {
                    map.remove();
                };
            }, 400); 
            return () => clearTimeout(timeoutId);
        }
    }, [openModalRastreamento, loadingHistorico, historicoRastreamento]);

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const [logsPgm, setLogsPgm] = useState([]);
    const [limit, setLimit] = useState(400);










    const processarIndexAtivarRele = (index) => {
        if (index === 1) {
            //rele 1
            return 1;
        } else if (index === 2) {
            //rele 2
            return 2;
        } else if (index === 3) {
            //rele 3
            return -1;
        } else if (index === 4) {
            //rele 4
            return -1;
        }
    }

    const processarIndexDesativarRele = (index) => {
        if (index === 1) {
            //rele 1
            return 4;
        } else if (index === 2) {
            //rele 2
            return 5;
        } else if (index === 3) {
            //rele 3
            return -1;
        } else if (index === 4) {
            //rele 4
            return -2;
        }
    }

    // Calcular a diferença de tempo
    const now = new Date();
    const lastResponse = new Date(equipamento.modulo_sentinel.data_hora_ultima_resposta);
    const differenceInMinutes = (now - lastResponse) / 1000 / 60; // Convertendo de milissegundos para minutos

    // Verificar se o alarme deve ser ativado
    const alarme = equipamento.alarme;

    // Definir o estado do equipamento
    let statusText;
    let statusColor;
    let isBlinking = false;

    const armada = equipamento.modulo_sentinel.armada;

    if (alarme) {
        statusText = "ALARME";
        statusColor = "red";
        isBlinking = true; // Habilitar o piscar se estiver em alarme
    } else if (differenceInMinutes < tempoInativo) {
        
            statusText = "ONLINE";
            statusColor = "green";
        
    } else {
        statusText = "OFFLINE";
        statusColor = "red";
        isBlinking = true; // Habilitar o piscar se estiver offline
    }



    const Zone = ({ zoneData }) => {

        const {
            id,
            nome,
            zoneStatus,
            armeStatus,
            zoneAlarme,
        } = zoneData;

        return (
            <Card sx={{ margin: 2, padding: 2, backgroundColor: "#f5f5f5" }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Zona {id}: {nome}
                    </Typography>
                    <Box sx={{ whiteSpace: "pre-line" }}>
                        <Typography><b>Online?</b> {zoneStatus}  </Typography>
                        <Typography><b>Armada?</b> {armeStatus}  </Typography>
                        <Typography><b>Em Alarme?</b> {zoneAlarme}</Typography>
                    </Box>
                </CardContent>
            </Card>
        );
    };



    return (
        <>
            {flag === 1 ? (
                <div style={{
                    backgroundColor: darkMode ? '#0f172a' : '#f8fafc',
                    borderRadius: '16px',
                    padding: '24px',
                    margin: '8px 0',
                    width: '100%',
                    fontFamily: '"Rajdhani", "Roboto", "Segoe UI", sans-serif',
                    boxShadow: darkMode ? '0 10px 40px rgba(0,0,0,0.5)' : '0 10px 40px rgba(0,0,0,0.08)',
                    border: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0',
                }}>
                    {/* HEADER IOT */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: darkMode ? '1px solid #1e293b' : '1px solid #e2e8f0', paddingBottom: '16px', marginBottom: '24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <div style={{
                                position: 'relative',
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                                <TrackChangesIcon style={{ color: alarme ? '#ef4444' : (statusColor === 'green' ? '#10b981' : '#f59e0b'), fontSize: 36, position: 'relative', zIndex: 2 }} />
                                <div style={{
                                    position: 'absolute',
                                    width: '40px', height: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: alarme ? '#ef4444' : (statusColor === 'green' ? '#10b981' : '#f59e0b'),
                                    opacity: 0.2,
                                    animation: isBlinking ? 'blink 2s infinite' : 'none',
                                    zIndex: 1
                                }} />
                            </div>
                            <div>
                                <Typography style={{ fontWeight: 800, fontSize: '1.4rem', letterSpacing: '0.5px', color: darkMode ? '#f8fafc' : '#0f172a', lineHeight: 1.2 }}>
                                    SENTINEL IOT <span style={{ color: '#10b981', fontSize: '0.8rem', backgroundColor: 'rgba(16, 185, 129, 0.1)', padding: '2px 8px', borderRadius: '12px', verticalAlign: 'middle', marginLeft: '8px' }}>v{equipamento.modulo_sentinel.firmware_version}</span>
                                </Typography>
                                <Typography style={{ fontSize: '0.85rem', color: darkMode ? '#94a3b8' : '#64748b', fontFamily: 'monospace', marginTop: '4px' }}>
                                    UUID: {equipamento.modulo_sentinel.codigo}
                                </Typography>
                            </div>
                        </div>
                        <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px' }}>
                            <div style={{ 
                                backgroundColor: alarme ? 'rgba(239,68,68,0.1)' : (statusColor === 'green' ? 'rgba(16,185,129,0.1)' : 'rgba(245,158,11,0.1)'),
                                color: alarme ? '#ef4444' : (statusColor === 'green' ? '#10b981' : '#f59e0b'),
                                padding: '6px 16px',
                                borderRadius: '24px',
                                border: `1px solid ${alarme ? 'rgba(239,68,68,0.3)' : (statusColor === 'green' ? 'rgba(16,185,129,0.3)' : 'rgba(245,158,11,0.3)')}`,
                                fontWeight: 700,
                                fontSize: '0.8rem',
                                letterSpacing: '0.5px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                boxShadow: alarme ? '0 0 15px rgba(239,68,68,0.2)' : 'none'
                            }}>
                                {isBlinking && <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'currentColor', animation: 'blink 1s step-start infinite' }}/>}
                                {statusText}
                            </div>
                            <Typography style={{ fontSize: '0.7rem', color: darkMode ? '#64748b' : '#94a3b8', fontFamily: 'monospace' }}>
                                ÚLT. SINCRONISMO: {equipamento.modulo_sentinel.data_hora_ultimo_registro_sentinel ? moment(equipamento.modulo_sentinel.data_hora_ultimo_registro_sentinel, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss DD/MM/YY") : 'N/A'}
                            </Typography>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                {equipamento.modulo_sentinel.tensao_bat_principal !== undefined && (
                                    <div 
                                        style={{ 
                                            display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer',
                                            backgroundColor: darkMode ? 'rgba(16, 185, 129, 0.1)' : 'rgba(16, 185, 129, 0.1)',
                                            padding: '4px 8px', borderRadius: '12px', border: darkMode ? '1px solid rgba(16, 185, 129, 0.2)' : '1px solid rgba(16, 185, 129, 0.2)',
                                            transition: 'transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                        onClick={handleAbrirBateria}
                                    >
                                        <Typography style={{ fontSize: '0.7rem', fontWeight: 800, color: darkMode ? '#10b981' : '#059669', letterSpacing:'0.5px' }}>
                                            ⚡ BAT: {(equipamento.modulo_sentinel.tensao_bat_principal > 0 ? equipamento.modulo_sentinel.tensao_bat_principal : (equipamento.modulo_sentinel.tensaoBateria || 0)).toFixed(2)}V
                                        </Typography>
                                    </div>
                                )}
                                {equipamento.modulo_sentinel.latitude != null && equipamento.modulo_sentinel.longitude != null && equipamento.modulo_sentinel.latitude !== 0 && (
                                    <div 
                                        style={{ position: 'relative' }}
                                        onMouseEnter={() => setShowMap(true)}
                                        onMouseLeave={() => setShowMap(false)}
                                        onClick={handleAbrirRastreamento}
                                    >
                                        <div style={{ 
                                            display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer',
                                            backgroundColor: darkMode ? 'rgba(56, 189, 248, 0.1)' : 'rgba(14, 165, 233, 0.1)',
                                            padding: '4px 8px', borderRadius: '12px', border: darkMode ? '1px solid rgba(56, 189, 248, 0.2)' : '1px solid rgba(14, 165, 233, 0.2)',
                                            transition: 'all 0.2s ease-in-out'
                                        }}>
                                            <LocationOnIcon style={{ fontSize: '1rem', color: darkMode ? '#38bdf8' : '#0ea5e9' }} />
                                            <Typography style={{ fontSize: '0.7rem', fontWeight: 800, color: darkMode ? '#38bdf8' : '#0ea5e9', letterSpacing:'0.5px' }}>
                                                LOCALIZAÇÃO
                                            </Typography>
                                        </div>

                                        {showMap && mapReady && (
                                            <div style={{ 
                                                position: 'absolute', top: '100%', right: 0, zIndex: 11000,
                                                width: '320px', paddingTop: '8px'
                                            }}>
                                                <div style={{
                                                    padding: '8px', borderRadius: '8px',
                                                    backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                                    boxShadow: '0 10px 25px rgba(0,0,0,0.5)', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0'
                                                }}>
                                                    <div style={{ fontSize: '0.8rem', fontWeight: 'bold', marginBottom: '8px', color: darkMode ? '#fff' : '#000' }}>
                                                        Registrado em: {equipamento.modulo_sentinel.data_hora_gps ? moment(equipamento.modulo_sentinel.data_hora_gps, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss DD/MM/YY") : 'N/A'}
                                                    </div>
                                                    <div 
                                                        ref={mapRef}
                                                        style={{ height: '180px', width: '100%', borderRadius: '8px', overflow:'hidden', backgroundColor:'#f0f0f0' }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* TELEMETRY DASHBOARD */}
                    <Grid container spacing={3}>
                        {/* 3D VISUALIZER PANEL */}
                        <Grid item xs={12} md={5}>
                            <div style={{
                                backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                borderRadius: '12px',
                                border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                                height: '100%',
                                position: 'relative',
                                overflow: 'hidden',
                                display: 'flex', flexDirection: 'column',
                                boxShadow: darkMode ? 'inset 0 2px 10px rgba(0,0,0,0.2)' : '0 2px 10px rgba(0,0,0,0.02)'
                            }}>
                                <div style={{ backgroundColor: darkMode ? '#0f172a' : '#f8fafc', padding: '10px 16px', fontSize: '0.75rem', fontWeight: 800, letterSpacing: '1px', color: darkMode ? '#cbd5e1' : '#475569', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>MODELO ESPACIAL <div style={{width:'4px', height:'4px', backgroundColor:'#3b82f6', borderRadius:'50%'}}/> </span>
                                    <span style={{ color: equipamento.modulo_sentinel.posicao_atual !== equipamento.posicao_instalacao ? '#ef4444' : '#10b981', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.7rem' }}>
                                        {equipamento.modulo_sentinel.posicao_atual !== equipamento.posicao_instalacao && <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#ef4444', animation: 'blink 1s infinite' }} />}
                                        {equipamento.modulo_sentinel.posicao_atual !== equipamento.posicao_instalacao ? 'DESALINHADO' : 'ALINHADO'}
                                    </span>
                                </div>
                                
                                {/* 3D Space */}
                                <div style={{ 
                                    flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', perspective: '800px', padding: '30px 0', 
                                    backgroundImage: darkMode 
                                        ? 'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)' 
                                        : 'linear-gradient(rgba(0,0,0,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.03) 1px, transparent 1px)', 
                                    backgroundSize: '20px 20px',
                                    backgroundPosition: 'center center'
                                }}>
                                    <div style={{ transformStyle: 'preserve-3d', transform: 'rotateX(-20deg) rotateY(-30deg)' }}>
                                        {/* O Cilindro 3D Modernizado */}
                                        <div style={{
                                            position: 'relative', width: '0px', height: '0px', transformStyle: 'preserve-3d',
                                            transform: `rotateX(${equipamento.modulo_sentinel.angulo_x || 0}deg) rotateZ(${-(equipamento.modulo_sentinel.angulo_y || 0)}deg)`,
                                            transition: 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)'
                                        }}>
                                            {Array.from({ length: 16 }).map((_, i) => (
                                                <div key={i} style={{
                                                    position: 'absolute', top: '-4.5px', left: '-50px', width: '100px', height: '9.5px', 
                                                    background: darkMode 
                                                        ? `hsl(215, 25%, ${20 + Math.cos(i * 22.5 * Math.PI / 180) * 15}%)` 
                                                        : `hsl(210, 20%, ${50 + Math.cos(i * 22.5 * Math.PI / 180) * 30}%)`,
                                                    borderTop: darkMode ? '1px solid rgba(255,255,255,0.02)' : '1px solid rgba(0,0,0,0.02)',
                                                    transform: `rotateX(${i * 22.5}deg) translateZ(20px)`, backfaceVisibility: 'hidden'
                                                }} />
                                            ))}
                                            <div style={{ position: 'absolute', top: '-20px', left: '-30px', width: '40px', height: '40px', borderRadius: '50%', background: darkMode ? '#0f172a' : '#334155', transform: 'rotateY(90deg) translateZ(50px)', backfaceVisibility: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', border: darkMode ? '2px solid #1e293b' : '2px solid #475569' }}>
                                                <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10b981', boxShadow: '0 0 12px #10b981', animation: 'blink 2s infinite' }} />
                                            </div>
                                            <div style={{ position: 'absolute', top: '-20px', left: '-30px', width: '40px', height: '40px', borderRadius: '50%', background: darkMode ? '#0f172a' : '#334155', transform: 'rotateY(-90deg) translateZ(50px)', backfaceVisibility: 'hidden', border: darkMode ? '2px solid #1e293b' : '2px solid #475569' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>

                        {/* KINEMATICS DATA */}
                        <Grid item xs={12} md={7}>
                            <Grid container spacing={2} style={{ height: '100%' }}>
                                <Grid item xs={6}>
                                    <div style={{ padding: '16px', backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <Typography style={{ fontSize: '0.7rem', color: darkMode ? '#94a3b8' : '#64748b', fontWeight: 800, letterSpacing: '1px', marginBottom: '8px' }}>CONFIG. MONTAGEM</Typography>
                                        <Typography style={{ fontSize: '1.4rem', fontWeight: 700, color: darkMode ? '#f8fafc' : '#0f172a' }}>{equipamento.posicao_instalacao === 0 ? 'HORIZONTAL' : 'VERTICAL'}</Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div style={{ padding: '16px', backgroundColor: equipamento.modulo_sentinel.posicao_atual !== equipamento.posicao_instalacao ? (darkMode ? 'rgba(239,68,68,0.1)' : '#fef2f2') : (darkMode ? 'rgba(16,185,129,0.05)' : '#f0fdf4'), borderRadius: '12px', border: equipamento.modulo_sentinel.posicao_atual !== equipamento.posicao_instalacao ? (darkMode ? '1px solid rgba(239,68,68,0.3)' : '1px solid rgba(239,68,68,0.3)') : (darkMode ? '1px solid #334155' : '1px solid #e2e8f0'), height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <Typography style={{ fontSize: '0.7rem', color: equipamento.modulo_sentinel.posicao_atual !== equipamento.posicao_instalacao ? '#ef4444' : (darkMode ? '#94a3b8' : '#64748b'), fontWeight: 800, letterSpacing: '1px', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            ESTADO ATUAL {equipamento.modulo_sentinel.posicao_atual !== equipamento.posicao_instalacao && <span style={{ animation: 'blink 1s infinite' }}>⚠️</span>}
                                        </Typography>
                                        <Typography style={{ fontSize: '1.4rem', fontWeight: 700, color: equipamento.modulo_sentinel.posicao_atual !== equipamento.posicao_instalacao ? '#ef4444' : (darkMode ? '#10b981' : '#059669') }}>
                                            {equipamento.modulo_sentinel.posicao_atual === 0 ? 'HORIZONTAL' : 'VERTICAL'}
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div style={{ padding: '16px', backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <Typography style={{ fontSize: '0.7rem', color: darkMode ? '#94a3b8' : '#64748b', fontWeight: 800, letterSpacing: '1px', marginBottom: '4px' }}>INCLINAÇÃO (EIXO-X)</Typography>
                                        <Typography style={{ fontSize: '2rem', fontWeight: 300, color: darkMode ? '#38bdf8' : '#0ea5e9', fontFamily: 'monospace', letterSpacing: '-1px' }}>{equipamento.modulo_sentinel.angulo_x?.toFixed(2)}°</Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div style={{ padding: '16px', backgroundColor: darkMode ? '#1e293b' : '#ffffff', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <Typography style={{ fontSize: '0.7rem', color: darkMode ? '#94a3b8' : '#64748b', fontWeight: 800, letterSpacing: '1px', marginBottom: '4px' }}>ROTAÇÃO (EIXO-Y)</Typography>
                                        <Typography style={{ fontSize: '2rem', fontWeight: 300, color: darkMode ? '#a78bfa' : '#8b5cf6', fontFamily: 'monospace', letterSpacing: '-1px' }}>{equipamento.modulo_sentinel.angulo_y?.toFixed(2)}°</Typography>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    align="center"
                    item xs={3}
                    style={{ padding: 1, margin: 0 }}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        align="center"
                        item xs={12}
                        style={{
                            boxShadow: alarme ? `0 0 30px 150px rgba(255, 0, 0, 0.5)` : "none", // Sombra afastada e translúcida
                        }}>
                        <Grid item xs={12}>
                            <TrackChangesIcon
                                style={{
                                    fontSize: 36,
                                    color: darkMode ? '#3b82f6' : '#2563eb'
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Tooltip
                                PopperProps={{
                                    sx: {
                                        zIndex: 11000
                                    }
                                }}
                                title={
                                    <Typography style={{ padding: 1, fontSize: '12px' }}>
                                        Última conexão: {moment(equipamento.modulo_sentinel.data_hora_ultima_resposta, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY [às] HH:mm:ss")}
                                    </Typography>
                                }
                                placement="top"
                                arrow
                            >
                                <span style={{ color: darkMode ? '#f8fafc' : '#0f172a', fontSize: '12px', fontWeight: '800', letterSpacing: '0.5px' }}>{equipamento.modulo_sentinel.codigo} </span>
                            </Tooltip>
                        </Grid>

                        <Grid item xs={12}>
                            <span style={{
                                color: statusColor,
                                fontSize: '11px',
                                fontWeight: '800',
                                textTransform: 'uppercase',
                                animation: isBlinking ? 'blink 2s step-start infinite' : 'none'
                            }}>
                                {statusText}
                            </span>
                        </Grid>
                    </Grid>
                </Grid>
            )}


            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    style: {
                        backgroundColor: snackbarSeverity === 'success' ? '#4caf50' : '#f44336',
                        marginTop: '60px', // Ajuste a altura conforme necessário
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: '1px solid black',
                        borderRadius: '4px',
                        padding: '10px',
                        zIndex: 555,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',

                    }
                }}
            />


            {/* Modal */}
            {openLogTable && (
                <div
                    style={{
                        position: "fixed",
                        top: "0",
                        left: "0",
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo escuro com opacidade
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: "199999",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            width: "80%",
                            height: "80%",
                            borderRadius: "8px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Sombra para destaque
                            display: "flex",
                            flexDirection: "column",
                            padding: "20px",
                            position: "relative",

                        }}
                    >
                        {/* Botão de fechar */}
                        <button
                            onClick={() => setOpenLogTable(false)}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                backgroundColor: "#FF4500",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                padding: "8px",
                                cursor: "pointer",
                                fontWeight: "bold",
                            }}
                        >
                            Fechar
                        </button>

                        {/* Conteúdo do Modal */}
                        <h6 style={{ marginTop: 0 }}>Historico de Eventos</h6>

                        {/* Espaço reservado para a tabela */}

                    </div>
                </div>
            )}

            {/* MODAL RASTREAMENTO */}
            <Modal
                isOpen={openModalRastreamento}
                onRequestClose={() => setOpenModalRastreamento(false)}
                style={{
                    content: {
                        top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                        marginRight: '-50%', transform: 'translate(-50%, -50%)',
                        width: '90%', maxWidth: '900px', height: '80vh',
                        padding: '0', borderRadius: '12px', overflow: 'hidden',
                        backgroundColor: darkMode ? '#0f172a' : '#fff', border: 'none'
                    },
                    overlay: { backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 10000 }
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div style={{ 
                        padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        backgroundColor: darkMode ? '#1e293b' : '#f8fafc', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0'
                    }}>
                        <Typography style={{ fontWeight: 800, color: darkMode ? '#f1f5f9' : '#1e293b' }}>
                            RASTREAMENTO - {equipamento.nome} ({equipamento.modulo_sentinel.codigo})
                        </Typography>
                        <IconButton onClick={() => setOpenModalRastreamento(false)} size="small" style={{ color: darkMode ? '#94a3b8' : '#64748b' }}>
                            <Close />
                        </IconButton>
                    </div>
                    
                    <div style={{ flex: 1, position: 'relative' }}>
                        {loadingHistorico ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                <Typography>Carregando histórico de rastreamento...</Typography>
                            </div>
                        ) : historicoRastreamento.length === 0 ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                <Typography>Nenhum dado de rastreamento encontrado nos últimos 3 dias.</Typography>
                            </div>
                        ) : (
                            <div ref={mapHistoricoRef} style={{ width: '100%', height: '100%' }} />
                        )}
                    </div>
                    
                    <div style={{ 
                        padding: '12px 24px', 
                        backgroundColor: darkMode ? '#1e293b' : '#f8fafc', 
                        borderTop: darkMode ? '1px solid #334155' : '1px solid #e2e8f0',
                        fontSize: '0.75rem', color: darkMode ? '#94a3b8' : '#64748b'
                    }}>
                        Exibindo {historicoRastreamento.length} pontos de localização capturados nos últimos 3 dias.
                    </div>
                </div>
            </Modal>

            {/* MODAL ANALISE BATERIA */}
            <Modal
                isOpen={openModalBateria}
                onRequestClose={() => setOpenModalBateria(false)}
                style={{
                    content: {
                        top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                        marginRight: '-50%', transform: 'translate(-50%, -50%)',
                        width: '90%', maxWidth: '1000px', height: '85vh',
                        padding: '0', borderRadius: '16px', overflow: 'hidden',
                        backgroundColor: darkMode ? '#0f172a' : '#fff', border: 'none',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
                    },
                    overlay: { backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 10000, backdropFilter: 'blur(4px)' }
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', fontFamily: '"Rajdhani", sans-serif' }}>
                    <div style={{ 
                        padding: '20px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        backgroundColor: darkMode ? '#1e293b' : '#f8fafc', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{ backgroundColor: '#10b981', width: '8px', height: '24px', borderRadius: '4px' }} />
                            <Typography style={{ fontWeight: 800, fontSize: '1.2rem', color: darkMode ? '#f1f5f9' : '#1e293b', letterSpacing: '0.5px' }}>
                                ANÁLISE DE ENERGIA - {equipamento.nome} {dadosBateria?.debug_count !== undefined && <span style={{fontSize:'0.7rem', color:'#94a3b8', marginLeft:'10px'}}>(Registros: {dadosBateria.debug_count})</span>}
                            </Typography>
                        </div>
                        <IconButton onClick={() => setOpenModalBateria(false)} size="small" style={{ color: darkMode ? '#94a3b8' : '#64748b' }}>
                            <Close />
                        </IconButton>
                    </div>
                    
                    <div style={{ flex: 1, padding: '24px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '24px' }}>
                        {loadingBateria ? (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: '16px' }}>
                                <div style={{ width: '40px', height: '40px', border: '4px solid #10b981', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
                                <Typography style={{ color: darkMode ? '#94a3b8' : '#64748b', fontWeight: 600 }}>Processando telemetria de 30 dias...</Typography>
                            </div>
                        ) : (!dadosBateria || !dadosBateria.historico || dadosBateria.historico.length === 0) ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                <Typography>Nenhum registro de bateria válido encontrado para este período.</Typography>
                            </div>
                        ) : (
                            <>
                                {/* INDICADORES RÁPIDOS */}
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={4}>
                                        <div style={{ padding: '20px', backgroundColor: darkMode ? '#1e293b' : '#f0fdf4', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #dcfce7', textAlign: 'center' }}>
                                            <Typography style={{ fontSize: '0.75rem', fontWeight: 800, color: '#10b981', letterSpacing: '1px', marginBottom: '8px' }}>DESCARGA TOTAL (30D)</Typography>
                                            <Typography style={{ fontSize: '2rem', fontWeight: 700, color: darkMode ? '#f8fafc' : '#065f46' }}>-{dadosBateria.descarregou_total.toFixed(2)}V</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <div style={{ padding: '20px', backgroundColor: darkMode ? '#1e293b' : '#fff7ed', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #ffedd5', textAlign: 'center' }}>
                                            <Typography style={{ fontSize: '0.75rem', fontWeight: 800, color: '#f59e0b', letterSpacing: '1px', marginBottom: '8px' }}>MÉDIA DE QUEDA DIÁRIA</Typography>
                                            <Typography style={{ fontSize: '2rem', fontWeight: 700, color: darkMode ? '#f8fafc' : '#9a3412' }}>{dadosBateria.media_diaria.toFixed(3)}V</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <div style={{ padding: '20px', backgroundColor: darkMode ? '#1e293b' : '#eff6ff', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #dbeafe', textAlign: 'center' }}>
                                            <Typography style={{ fontSize: '0.75rem', fontWeight: 800, color: '#3b82f6', letterSpacing: '1px', marginBottom: '8px' }}>AUTONOMIA ESTIMADA</Typography>
                                            <Typography style={{ fontSize: '2rem', fontWeight: 700, color: darkMode ? '#f8fafc' : '#1e3a8a' }}>~{Math.round(dadosBateria.previsao_dias)} DIAS</Typography>
                                        </div>
                                    </Grid>
                                </Grid>

                                {/* GRÁFICO */}
                                <div style={{ 
                                    flex: 1, minHeight: '300px', backgroundColor: darkMode ? '#1e293b' : '#fff', 
                                    padding: '24px', borderRadius: '12px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0'
                                }}>
                                    <Typography style={{ fontSize: '0.9rem', fontWeight: 700, marginBottom: '20px', color: darkMode ? '#cbd5e1' : '#475569', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        📉 CURVA DE TENSÃO (PRINCIPAL)
                                    </Typography>
                                    <ResponsiveContainer width="100%" height="90%">
                                        <AreaChart data={dadosBateria.historico}>
                                            <defs>
                                                <linearGradient id="colorTensao" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="5%" stopColor="#10b981" stopOpacity={0.3}/>
                                                    <stop offset="95%" stopColor="#10b981" stopOpacity={0}/>
                                                </linearGradient>
                                            </defs>
                                            <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? "#334155" : "#e2e8f0"} vertical={false} />
                                            <XAxis 
                                                dataKey="data_hora" 
                                                tickFormatter={(str) => moment(str).format("DD/MM")} 
                                                stroke={darkMode ? "#94a3b8" : "#64748b"}
                                                fontSize={12}
                                                tickLine={false}
                                                axisLine={false}
                                            />
                                            <YAxis 
                                                domain={[5.5, 9]} 
                                                stroke={darkMode ? "#94a3b8" : "#64748b"}
                                                fontSize={12}
                                                tickLine={false}
                                                axisLine={false}
                                                tickFormatter={(val) => `${val}V`}
                                            />
                                            <ChartTooltip 
                                                contentStyle={{ backgroundColor: darkMode ? '#1e293b' : '#fff', border: `1px solid ${darkMode ? '#334155' : '#e2e8f0'}`, borderRadius: '8px' }}
                                                labelFormatter={(str) => moment(str).format("DD/MM/YYYY HH:mm")}
                                            />
                                            <Area 
                                                type="monotone" 
                                                dataKey="tensao" 
                                                stroke="#10b981" 
                                                strokeWidth={3}
                                                fillOpacity={1} 
                                                fill="url(#colorTensao)" 
                                                name="Tensão (V)"
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>

                                {/* LEGENDA DE NÍVEIS */}
                                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#10b981' }} /> Cheia: 8.4V
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#3b82f6' }} /> Nominal: 7.4V
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#f59e0b' }} /> Crítica: 6.4V
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: darkMode ? '#94a3b8' : '#64748b' }}>
                                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#ef4444' }} /> Shutdown: 6.0V
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Modal>
        </>
    );


}

